import { FC } from 'react';

import EditorWarningIcon from '@atlaskit/icon/glyph/editor/warning';


interface AlertaInlineProps {
  mensagem?: string
}

export const AlertaInline: FC<AlertaInlineProps> = ({mensagem}) => {
  if (mensagem === undefined) {
    return <></>
  }

  return <>
    <span title={mensagem} style={{cursor: "pointer"}}>
      <EditorWarningIcon label={mensagem} aria-hidden="true" primaryColor="#f39c12" />
    </span>
  </>
}